import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/betstride/images/logo.png';

export default function Index() {
  return <Image src={logo} ml="2" mt="2" width="60px" />;
}
